import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Container } from '@nfs-react/components';

import { Button } from 'helpers/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';

const Top = ({ handleScroll }) => {
  return (
    <Wrapper>
      <TopContainer>
        <TopImage>{useImg('mobImg.png', 'mobile_img')}</TopImage>
        <Content>
          <Title>{useText('top__title', true)}</Title>
          <Subtitle>{useText('top__subtitle', true)}</Subtitle>
          <Button buttonCss={btnCss} clickHandler={handleScroll}>
            {useText('top__btn', true)}
          </Button>
        </Content>
      </TopContainer>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: relative;
  background-position: center top;
  background-repeat: no-repeat;

  @media ${DESKTOP} {
    padding-top: 35px;
    min-height: 390px;
    background-position: center;
    background-size: 1920px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('top-bg-d.jpg')};
  }

  @media ${TABLET} {
    padding-top: 35px;
    min-height: 570px;
    background-position: center;
    background-size: 1199px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('top-bg-t.jpg')};
  }

  @media ${MOBILE} {
    padding-top: 35px;
    min-height: 570px;
    background-position: center;
    background-size: 767px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('top-bg-t.jpg')};
  }
`;

const TopContainer = styled(Container)`
  @media ${DESKTOP} {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
  }

  @media ${TABLET} {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }

  @media ${MOBILE} {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }
`;

const TopImage = styled.div`
  @media ${DESKTOP} {
    display: none;
  }

  @media ${MOBILE} {
  }
`;

const Content = styled.div`
  @media ${DESKTOP} {
    padding-top: 27px;
    padding-left: 638px;
  }

  @media ${MOBILE} {
    margin-bottom: 30px;
  }
`;

const Title = styled.div`
  margin: 0 auto 95px;
  font-weight: 500;
  font-size: 36px;
  line-height: 40px;
  text-align: center;
  color: #c7af95;

  @media ${TABLET} {
    font-size: 36px;
  }

  @media ${MOBILE} {
    font-size: 36px;
    margin: 0 auto 65px;
  }
`;

const Subtitle = styled.div`
  margin: 0 auto 33px;
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #eee5cc;

  @media ${TABLET} {
    font-size: 24px;
    margin: 0 auto 23px;
  }

  @media ${MOBILE} {
    font-size: 24px;
  }
`;

const btnCss = css`
  background: linear-gradient(#b18e69, #bbb19c);
  color: black;
  font-weight: 500;
  padding: 9px 34px;
  max-width: 653px;
  margin: 0 auto;
  font-size: 16px;
`;

Top.propTypes = {
  handleScroll: PropTypes.func.isRequired,
};

export default Top;
